var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse-box',{attrs:{"collapseData":_vm.dataByProjectCategory,"spinning":_vm.spinning},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var solution = ref.record;
return [_c('solution-item',{key:solution.id,attrs:{"solution":solution,"active":_vm.activeId === solution.id},on:{"click":function($event){return _vm.viewDetail(solution)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }